import { event } from '@rategravity/frontend/modules/user-actions';
import Immutable from 'immutable';
import querystring from 'querystring';

const doPrefill = ({ fields, mutation, vals, prefillItems, prefillItemsBool }) => {
  // Collect the Info and Add to Mutation fields
  Object.keys(vals).forEach((k) => {
    if (prefillItems.indexOf(k) > -1) {
      if (vals[k] !== '') {
        fields[k] = vals[k];
      }
    } else if (prefillItemsBool.indexOf(k) > -1) {
      /**
       * If the value of k is equal to 'true' (string),
       *   set it to the boolean true in the field obj.
       *   If the value of k is equal to 'false' (string),
       *   set it to the boolean false in the field obj.
       */
      if (vals[k] === 'true') {
        fields[k] = true;
      } else if (vals[k] === 'false') {
        fields[k] = false;
      }
    }
  });

  if (Object.keys(fields).length > 0) {
    mutation(fields);
  }
};

const prefillLoan = ({ loan, mutation, vals, scenario, actionPipe }) => {
  const fields = {};
  // If path differs from saved scenario... update scenario to new path value
  if (scenario && scenario !== loan.scenario) {
    fields.scenario = scenario;
  }

  doPrefill({
    fields,
    vals,
    mutation: (fields) => {
      actionPipe.next(event('LoadQuestionnaire', fields));
      if (
        fields.scenario != null &&
        fields.scenario !== 'RefiQualify' &&
        fields.scenario !== 'Qualify'
      ) {
        actionPipe.next(event('Load Funnel Questionnaire', fields));
      }

      mutation({
        loan,
        fields: Immutable.fromJS(fields)
      });
    },
    prefillItems: ['advisor', 'preapprovalState', 'loanState', 'refiPurpose', 'purchaseTimeFrame'],
    prefillItemsBool: ['previousPreapproval', 'acceptedOffer', 'otherOffer', 'pitch']
  });
};

const prefillBorrower = ({ borrower, mutation, vals, hubspotToken }) => {
  const fields = {};
  if (hubspotToken) {
    fields.hubspotToken = hubspotToken;
  }
  return doPrefill({
    fields,
    vals,
    mutation: (fields) =>
      mutation({
        borrower,
        fields: Immutable.fromJS(fields)
      }),
    prefillItems: ['name', 'email'],
    prefillItemsBool: ['firstTimeBuyer']
  });
};

export default ({
  viewer,
  updateLoan,
  updateBorrower,
  scenario,
  hubspotToken,
  url,
  actionPipe
}) => {
  const vals = querystring.parse(url.replace('?', ''));
  if (process.env.DEPLOY_ENV === 'staging') {
    // TEST PATH FOR USER TESTING
    console.log('Received query params:', vals);
    if (vals.test) {
      console.log('Test Path set to', vals.test);
      sessionStorage.setItem('testPath', vals.test);
      delete vals.test;
    } else {
      console.log('Test Path unset');
      sessionStorage.removeItem('testPath');
    }
  }
  prefillLoan({
    loan: viewer.activeLoan,
    mutation: updateLoan,
    vals,
    scenario,
    actionPipe
  });
  prefillBorrower({
    borrower: viewer.primaryBorrower,
    mutation: updateBorrower,
    vals,
    hubspotToken
  });
};



// WEBPACK FOOTER //
// ./src/modules/prefill.js